<template>
  <b-row>
		<b-col style="margin-left: 10px;margin-right: 10px;">
			<PedidoTable
        id="pedidos_table"
        primaryKey="id"
        :items="pedidos"
        :fields="fields"
        :onEdit="pedidoDetails"
        :onFecharPedido="onFecharPedido"
        :onBaixarPDF="baixarPDF">
      </PedidoTable>
      <br>
      <b-row cols="12" style="margin-left: 5px;margin-right: 5px;float:right">
        <b-button variant="primary" @click="add" style="margin-right: 5px;">
          <b-icon icon="plus-circle"></b-icon>&nbsp;Novo
        </b-button>
        <b-button variant="warning" @click="list" id="refresh">
          <b-icon icon="arrow-repeat"></b-icon> &nbsp;Atualizar
        </b-button>
      </b-row>
		</b-col>
    <PedidoDetail 
    :pedido="this.pedido" 
    :onCloseModal="this.list"/>

    <PedidoDetailMobile
      :pedido="this.pedido" 
      :onCloseModal="this.list"/>

    <b-modal
      id="fechar_pedido"
      header-bg-variant="danger"
      title="Fechamento de pedido"
      size="lg"
      @hidden="cancelarFechamentoPedido">

      <h3>Confirma o Fechamento do Pedido?</h3>
      <template v-slot:modal-footer>
        <div style="padding: 0 5px 0 0">
          <b-button variant="danger" @click="fecharPedido" id="btn_confirm">
            Fechar Pedido
          </b-button>
        </div>
        <div>
          <b-button
            variant="primary"
            @click="cancelarFechamentoPedido"
            id="btn_cancel">
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>
	</b-row>  
</template>

<script>
import PedidoTable from "@/components/tables/PedidoTable";
import PedidoServices from "@/services/Pedido";
import utilServices from "@/services/Util";
import { getEnum } from "@/util/ConstEnuns";
import mascaras from "@/util/Mascaras";
import PedidoDetail from "./detail";
import PedidoDetailMobile from "./detail_mobile";

export default {
  name: "Pedidos",

  components: {
    PedidoTable,
    PedidoDetail,
    PedidoDetailMobile,
  },

  data() {
    return {
      loading: false,

      pedidos: [],

      pedido: {},

      fields: [
        {
          key: "IDCAB",
          sortable: true,
          label: "N°",
          class: "pedido-data-table-id",
        },
        {
          key: "QTD_ITENS",
          sortable: true,
          label: "QTD",
          class: "pedido-data-table-id",
        },
        {
          key: "NAT_OP",
          sortable: true,
          label: "Tipo",
          formatter: (value) => {
            return getEnum("natureza_operacao", value);
          },
        },
        {
          key: "DATA",
          sortable: true,
          label: "Data",
          class: "pedido-data-table-data",
          formatter: (value, key, item) => {
            return mascaras.formataData(item.DATA, value);
          },
        },
        { key: "actions", label: "Ações", class: "pedido-data-table-acoes" },
      ],
    };
  },

  created: function() {
    this.list();
  },

  methods: {
    add() {
      let pedidoAberto = false;
      for (let i = 0; i < this.pedidos.length; i++) {
        if (this.pedidos[i].STATUS != 'F') {
          pedidoAberto = true;
          break;
        }
      }
      if (pedidoAberto)
        this.$bvToast.toast('Existe(m) orçamento(s) em aberto. Finalize-o(s) antes de criar um novo.', {title: "Aviso", variant: "warning", solid: true});
      else
        this.pedidoDetails({ IDCAB: 0 });
    },

    list() {
      let loader = this.$loading.show({});
      PedidoServices.list()
      .then((response) => {
          if (response.data.RET == 1) this.pedidos = response.data.OBJ;
          else
            this.$bvToast.toast(response.data.OBJ[0].MSG, {
              title: "Erro",
              variant: "danger",
              solid: true,
            });
      })
      .catch((error) => {
        utilServices.parseServerError(error, this);
      })
      .finally(() => {
        loader.hide();
      });
    },

    pedidoDetails(item) {
      this.pedido = item;      
      //if (!this.isMobile())
      //  this.$bvModal.show("cadastro_pedido");
      //else
        this.$bvModal.show("cadastro_pedido_mobile");
    },

    onFecharPedido(item) {
      this.pedido = item;        
      this.$bvModal.show("fechar_pedido");
    },

    cancelarFechamentoPedido() {
      this.pedido.STATUS = "A";
      this.pedido = {};
      this.$bvModal.hide("fechar_pedido");
    },

    fecharPedido() {  
      let loader = this.$loading.show({});  
      this.pedido.STATUS = 'F';  
      PedidoServices.save(this.pedido)
      .then(
        (response) => {
          if (response.status === 200) {
            if (response.data.RET == "1") {
              this.pedido = {};
              this.list();
              this.$bvModal.hide("fechar_pedido");
              this.$root.$bvToast.toast("Pedido fechado com sucesso.", {
                title: "Sucesso",
                variant: "success",
                solid: true,
              });
            } else {
              this.$root.$bvToast.toast(response.data.OBJ[0].MSG, {
                title: "Erro",
                variant: "danger",
                solid: true,
              });
              this.pedido.STATUS = 'E';
            }
          }
        })
      .catch((error) => {
        utilServices.parseServerError(error, this);
      })
      .finally(() => {
        loader.hide();
      });
    },

    baixarPDF(pedido) {
      let loader = this.$loading.show({});  
      PedidoServices.getPDF(pedido.IDCAB)
        .then((response) => {         
          var blob = new Blob([response.data], {type: "application/pdf"},);
          if (!this.isMobile())
            window.open(URL.createObjectURL(blob));
          else {       
            var link = document.createElement('a');
            link.href = PedidoServices.getPDFFile(pedido.IDCAB);            
            link.download = "pedido_"+ pedido.IDCAB +".pdf";
            link.target = "_blank";
            link.click();            
          }
        })
        .catch((error) => {
          utilServices.parseServerError(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },

    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
};
</script>
